import React from 'react'

const SingleDest = ({ hotel, setHotelName}) => {
    const {image, name, description, rating, price} = hotel && hotel

    return (
        <>
            <div className="grid grid-cols-2 gap-5">
                <img style={{ width: '270px', height: '200px' }} src={image} alt="" />
                <div>
                    <p className="text-lg font-semibold">{name}</p>
                    <p className="text-gray-500">{description}</p>
                    <div className="flex justify-between leading-9">
                        <p className="font-semibold">⭐{rating}</p>
                        <p>
                            <span className="font-semibold">${price}</span>/<span className="text-gray-500">night</span>{' '}
                        </p>
                    </div>
                    <div className='flex justify-between'>
                        <label onClick={() => setHotelName(name)} htmlFor="hotel-booking-modal" className="btn btn-primary btn-sm">Book Now</label>
                        <button className="btn btn-secondary btn-sm">Save</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SingleDest
